<template lang="pug">
action-bar(
  :entity="entity"
  @perform="opts => $emit('perform', opts)"
)

  //- BOTÃO DE FILTRO
  template(#navbar v-if="!value")

  template(#right)

    //- //- SINCRONIZAÇÃO
    //- //-
    //- v-menu(
    //-   bottom left offset-y
    //- )
    //-   template(v-slot:activator="{ on, attrs }")
    //-     v-btn.ml-1(
    //-       text
    //-       rounded
    //-       v-bind="attrs"
    //-       v-on="on"
    //-     )
    //-       v-icon mdi-refresh
    //-       v-icon(right) mdi-chevron-down

    //-   v-list
    //-     v-subheader Auto-Sincronização

    //-     v-list-item(
    //-       v-for="(interval,index) in autoRestoreIntervals"
    //-       :key="`interval-${index}`"
    //-       @click="autoRestoreSeconds = interval.seconds"
    //-     )
    //-       v-list-item-avatar
    //-         v-icon(
    //-           v-show="interval.selected"
    //-           left
    //-         )
    //-           | mdi-check

    //-       v-list-item-content
    //-         v-spacer
    //-         | {{ interval.text }}


    //- BOTÃO DE FILTRO
    grid-filter-btn(
      v-bind="$props"
      @input="value => $emit('input',value)"
    )

    //- BOTÃO DE ATUALIZAR
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn.mx-1(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('refresh')"
        )
          v-icon mdi-refresh
      span
        span.text-md.font-weight-medium Atualizar
        br
        span.font-weight-light Sincroniza os dados da grade com o servidor de dados.
</template>

<script>
import ActionBar from '@/components/commons/action-bar/ActionBar'
import GridFilterBtn from './GridFilterBtn'

export default {
  components: {
    ActionBar,
    GridFilterBtn,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,

    /**
     * Coleção dos registros selecionados na grade.
     */
    selection: Array,
  },

  data: () => ({
  }),

  computed: {
    autoRestoreSeconds: {
      get () {
        return this.entity?.autoRefresh || 0
      },
      set (value) {
        this.entity && (this.entity.autoRefresh = value)
      }
    },

    autoRestoreIntervals () {
      const intervals = [
        { seconds: 2,     text: '2 segundos'          },
        { seconds: 3,     text: '3 segundos'          },
        { seconds: 5,     text: '5 segundos'          },
        { seconds: 10,    text: '10 segundos'         },
        { seconds: 20,    text: '20 segundos'         },
        { seconds: 30,    text: '30 segundos'         },
        { seconds: 60,    text: '1 minuto'            },
        { seconds: 60*60, text: '1 hora'              },
        { seconds: 0,     text: 'Atualização manual'  },
      ]
      const current = this.autoRestoreSeconds
      intervals.forEach(interval =>
        interval.selected = (interval.seconds === current)
      )
      return intervals
    },
  },
}
</script>